import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    centerFields: {
      fontSize: 12,
      maxWidth: 60,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '& .MuiIconButton-root': {
        padding: 0,
      },
    },
    centerLongFields: {
      fontSize: 12,
      maxWidth: 75,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '& .MuiIconButton-root': {
        padding: 0,
      },
    },
    centerSmallFields: {
      textAlign: 'center',
      fontSize: 12,
      justifyContent: 'center',
      maxWidth: 30,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '& .MuiIconButton-root': {
        padding: 0,
      },
      '& .makeStyles-cellContent': {
        justifyContent: 'center',
      },
      '& div': {
        justifyContent: 'center',
      },
    },
    emailField: {
      maxWidth: 160,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    backIcon: { width: 15, height: 15 },
    restoreButton: {
      border: `1px solid ${palette.green}`,
      color: palette.green,
      fontSize: 12,
    },
    actionsButtonsGrid: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    checkboxCell: {
      padding: '0 0 0 8px',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },
    selectedUsersCounter: {
      marginBottom: 8,
      '& .MuiTypography-root': {
        fontSize: 12,
      },
    },
  });
